import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Spinner from 'components/spinner/Spinner';
import Tooltip from 'components/Tooltip';

import { t } from 'utils/language';

import './deliverable-media-upload-placeholder.scss';

type ModeType = 'create' | 'uploading' | 'drop';

type Props = {
  size: 'small' | 'normal' | 'big' | (string & {}),
  mode: ModeType,
  tooltip?: string,
  progress?: number
};

class DeliverableMediaUploadPlaceholder extends React.PureComponent<Props> {
  private renderProgressBar(): React.ReactNode {
    const { progress } = this.props;

    if (isNil(progress)) {
      return (
        <Spinner
          position="inline"
          size="small"
          color="light"
        />
      );
    }

    return (
      <React.Fragment>
        <VerticalSpacing type="medium" />
        <div className="deliverable-media-upload-placeholder__progress-bar">
          <div
            className="deliverable-media-upload-placeholder__progress-bar-inner"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="deliverable-media-upload-placeholder__progress-info">
          {Math.round(progress)}%
        </div>
      </React.Fragment>
    );
  }

  renderContent(mode: ModeType): React.ReactNode {
    let content: React.ReactNode = null;


    switch (mode) {
      case 'create':
        content = (
          <SVGDynamicIcon
            name="plus-inside-circle-custom-bg"
            width={25}
            height={25}
            customColor="grey-light"
          />
        );
        break;
      case 'uploading':
        content = (
          <div className="deliverable-media-upload-placeholder__uploading-container">
            {this.renderProgressBar()}
          </div>
        );
        break;
      case 'drop':
        content = t('deliverable_media.button_drop_here');
        break;
      default:
        break;
    }

    return content;
  }

  render(): React.ReactNode {
    const { mode, size, tooltip } = this.props;
    const classes = classnames({
      'deliverable-media-upload-placeholder': true,
      [`deliverable-media-upload-placeholder--mode-${mode}`]: mode,
      [`deliverable-media-upload-placeholder--size-${String(size)}`]: size
    });

    const component = (
      <section className={classes}>
        {this.renderContent(mode)}
      </section>
    );

    if (mode === 'create') {
      return (
        <Tooltip
          message={tooltip || t('deliverable_media.tooltip_upload_here')}
          width="long"
        >
          {component}
        </Tooltip>
      );
    }

    return component;
  }
}

export default DeliverableMediaUploadPlaceholder;
